module.exports = __webpack_public_path__ + "img/solidaridad.8c5d7c2f.svg";